import { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { useDispatch } from 'react-redux'

import { useModal } from '@/hooks/useModal'
import { useToast } from '@/hooks/useToast'
import { api } from '@/services/api'
import { handleSetSocialMedia } from '@/storage/modules/socialMedia/reducer'
import { SocialMediaResponseProps } from '@/types/socialMediaProps'

import { Button } from '../Button'
import { Input } from '../form/Input'

interface FormSocialMediaProps {
  isExist?: SocialMediaResponseProps
}

export function FormSocialMedia({ isExist }: FormSocialMediaProps) {
  const { register, handleSubmit, setValue } =
    useForm<SocialMediaResponseProps>()

  const [isLoading, setIsLoading] = useState(false)

  const dispatch = useDispatch()
  const { showToast } = useToast()
  const { closeModal } = useModal()

  const refreshSocialMedia = async () => {
    const response = await api
      .get('/social-media')
      .then((res) => res.data.data as SocialMediaResponseProps[])

    dispatch(handleSetSocialMedia({ socialMedia: response }))
  }

  const onSubmit = async (data: SocialMediaResponseProps) => {
    try {
      setIsLoading(true)

      if (isExist) {
        await api.patch(`/social-media/${isExist.id}`, data)

        showToast('Social media edited successfully', {
          type: 'success',
          theme: 'light',
        })
      } else {
        await api.post('/social-media', data)

        showToast('Social media added successfully', {
          type: 'success',
          theme: 'light',
        })
      }

      await refreshSocialMedia()
      closeModal()
    } catch (err: unknown) {
      const errMessage =
        err instanceof Error ? err.message : 'Error saving social media'
      const apiMessage =
        typeof err === 'object' &&
        err !== null &&
        'response' in err &&
        typeof err.response === 'object' &&
        err.response !== null &&
        'data' in err.response &&
        typeof err.response.data === 'object' &&
        err.response.data !== null &&
        'message' in err.response.data &&
        typeof err.response.data.message === 'string'
          ? err.response.data.message
          : errMessage

      showToast(`${apiMessage}`, {
        type: 'error',
        theme: 'light',
      })
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    if (isExist) {
      setValue('title', isExist.title)
    }
  }, [isExist, setValue])

  return (
    <div>
      <form onSubmit={handleSubmit(onSubmit)} className="flex flex-col gap-4">
        <Input
          placeholder="Digit social media title"
          label="Social Media"
          name="title"
          register={register}
          required
        />

        <Button
          title={isExist ? 'Edit' : 'Save'}
          variant="purple"
          isLoading={isLoading}
        />
      </form>
    </div>
  )
}
